import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { useYupFields } from 'hooks/forms/useYupFields'

export type SendDetailsFormData = {
  sendAmount: string
  receiveAmount: string
  reference: string
}

export type SendDetailsFormKeys = keyof SendDetailsFormData

export const sendDetailsSchema = (t: TFunction<'translation', string>) => {
  const { getYupField } = useYupFields()

  return yup.object<Record<SendDetailsFormKeys, yup.StringSchema>>({
    sendAmount: getYupField({
      label: t('formFields.sendAmount'),
    }),
    receiveAmount: getYupField({
      label: t('formFields.receiveAmount'),
    }),
    reference: getYupField({
      label: t('formFields.uniqueReference'),
    }),
  })
}
